import actions from './actions'

const state = {
  itineraryTemplate: null
}

const itineraryTemplate = {
  namespaced: true,
  state,
  actions
}

export default itineraryTemplate
